import { render, staticRenderFns } from "./phoneDeclaration.vue?vue&type=template&id=1fbc826a&scoped=true&"
import script from "./phoneDeclaration.vue?vue&type=script&lang=js&"
export * from "./phoneDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./phoneDeclaration.vue?vue&type=style&index=0&id=1fbc826a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbc826a",
  null
  
)

export default component.exports